import React from 'react';
import Header from './header';
import Footer from './footer';
import { Helmet } from 'react-helmet-async';

const Layout = ({title, children}) => {
    return ( 
        <>
            <Helmet>
                <title>{ title ? title + " - Amazon Digital Office" : "Amazon Digital Office" }</title>
                <meta 
                    name="description"
                    content="Automate your business processes and digital forms with eSignatures on Amazon Digital Office.  Digital Transformation made easy."
                />
                <meta 
                    name="keywords"
                    content="Digital Transformation, eSignture, Business Automation, Digital Forms"
                />
            </Helmet>
            <Header />
            {children}
            <Footer />
        </>
     );
}
 
export default Layout;